import type { RoomState, TournamentState } from '@sprinters/shared';

export type ConnectionStatus = 'connecting' | 'connected' | 'disconnected';

export interface Session {
  playerId: string;
  code: string;
}

export interface AppState {
  connection: ConnectionStatus;
  pingMs: number | null;
  session: Session | null;
  room: RoomState | null;
  tournament: TournamentState | null;
  /** `performance.now()` à la réception du dernier état : sert à recalculer les temps restants. */
  tournamentReceivedAt: number;
  /** Série suivie par ce client (la sienne ou une série spectateur). */
  watchingHeatId: string | null;
  /** Instant local (`performance.now()`) du signal de départ de la série suivie. */
  goAt: number | null;
}

export const initialState: AppState = {
  connection: 'connecting',
  pingMs: null,
  session: null,
  room: null,
  tournament: null,
  tournamentReceivedAt: 0,
  watchingHeatId: null,
  goAt: null,
};

type Listener = (state: AppState, previous: AppState) => void;

/** Store minimal : état immuable + abonnements. */
export class Store {
  private state: AppState = initialState;
  private readonly listeners = new Set<Listener>();

  get(): AppState {
    return this.state;
  }

  set(patch: Partial<AppState>): void {
    const previous = this.state;
    this.state = { ...previous, ...patch };
    for (const listener of this.listeners) listener(this.state, previous);
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}

export const store = new Store();
